import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { ModalDialog } from 'core-components/library/modalDialog'

import {
  requestBusinessPrioritiesData,
  selectBusinessPrioritiesSelectedFYear,
  selectBusinessPrioritiesUserInfo,
  useBusinessPrioritiesView,
} from '../../model'
import { BusinessPrioritiesEditView, BusinessPrioritiesListView } from '../views'

import styles from './BusinessPriorities.module.scss'

export const BusinessPriorities = () => {
  const { activeView, goToList } = useBusinessPrioritiesView()

  const dispatch = useAppDispatch()
  const fYear = useSelector(selectBusinessPrioritiesSelectedFYear)
  const userInfo = useSelector(selectBusinessPrioritiesUserInfo)
  const market = useMemo(() => userInfo?.market || '', [userInfo])

  useEffect(() => {
    dispatch(requestBusinessPrioritiesData())
  }, [dispatch])

  return (
    <div className={styles.root}>
      <BusinessPrioritiesListView fYear={fYear} market={market} />

      <ModalDialog
        show={activeView === 'edit'}
        onClose={goToList}
        size="sm"
        content={() => <BusinessPrioritiesEditView />}
      />
    </div>
  )
}

BusinessPriorities.displayName = 'BusinessPriorities'

export default BusinessPriorities
